/**
 *
 * @param {Array<PropertyValueProps>} values
 */
const getValuesArray = (values) => {
  return values.map((item) => item.get("v_value"));
}

export default getValuesArray;